export default __webpack_public_path__ + "static/phantomdao-4cbfe770ad962cb746cace920ee370d5.jpg";